// src/features/Analytics/components/TensorFlowStatus.jsx
import React from 'react';
import {
  Box,
  Chip,
  Typography,
  Tooltip,
  LinearProgress,
  Alert
} from '@mui/material';
import {
  Memory,
  Speed,
  Psychology,
  DeveloperBoard,
} from '@mui/icons-material';
import { useI18n } from '../../../i18n/i18n';

const TensorFlowStatus = ({ modelInfo, isLoading }) => {
  const { t } = useI18n();

  if (isLoading) {
    return (
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
        <LinearProgress sx={{ width: 100 }} />
        <Typography variant="body2" color="text.secondary">
          {t('ml_tf_initializing')}
        </Typography>
      </Box>
    );
  }

  if (!modelInfo.usingTensorFlow) {
    return (
      <Chip
        icon={<Memory />}
        label={t('ml_tf_using_simple')}
        color="default"
        variant="outlined"
        size="small"
      />
    );
  }

  return (
    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
      <Tooltip title={`TensorFlow.js with ${modelInfo.backend} backend`}>
        <Chip
          icon={<Psychology />}
          label="TensorFlow.js"
          color="success"
          variant="filled"
          size="small"
        />
      </Tooltip>
      
      <Tooltip title={t('ml_tf_backend')}>
        <Chip
          icon={<Speed />}
          label={modelInfo.backend}
          color="info"
          variant="outlined"
          size="small"
        />
      </Tooltip>

      <Typography variant="caption" color="text.secondary">
        {t('ml_tf_accuracy', { accuracy: modelInfo.accuracy.toFixed(1) })}
      </Typography>
    </Box>
  );
};

export default TensorFlowStatus;